import _default from "@emotion/styled";

const colors = {
  background: "#101010",
  foreground: "##F1F1F1",
  white: "#CDCDCD",
  primary: {
    50: "#fff3eb",
    100: "#fed9c0",
    200: "#fec6a2",
    300: "#fead78",
    400: "#fd9d5d",
    500: "#fd8435",
    600: "#e67830",
    700: "#b45e26",
    800: "#8b491d",
    900: "#6a3716",
  },
  success: {
    50: "#f3fae8",
    100: "#d9efb7",
    200: "#c6e894",
    300: "#addd63",
    400: "#9dd645",
    500: "#84cc16",
    600: "#78ba14",
    700: "#5e9110",
    800: "#49700c",
    900: "#375609",
  },
  neutral: {
    50: "#ffffff", // Pure White
    100: "#f8f8f8",
    200: "#f2f2f2",
    300: "#ebebeb",
    400: "#e4e4e4",
    500: "#d4d4d8",
    600: "#a1a1aa",
    700: "#71717a",
    800: "#52525b",
    900: "#3f3f46",
    950: "#27272a",
    975: "#18181b",
    990: "#111111",
  },
  shadow: {
    primary: "0 0 0 4px #5D3710",
    success: "0 0 0 4px rgba(132, 204, 22, 0.3)",
    error: "0 0 0 4px rgba(255, 59, 48, 0.4)",
    warning: "0 0 0 4px rgba(255, 204, 0, 0.4)",
    white: "0 0 4px 4px rgba(255, 255, 255, 0.2)",
  },
  shades: {
    primary: "#5D3710",
    success: "rgba(132, 204, 22, 0.15)",
    error: "rgba(255, 59, 48, 0.15)",
    warning: "rgba(255, 204, 0, 0.15)",
    white: "rgba(255, 255, 255, 0.15)",
  },
};

export { colors };
